import * as Yup from 'yup';

const httpsUrlValidator = Yup.string()
  .url()
  .matches(/(^(https)?:\/\/)/, 'Enter correct url (starting with https://)');

export { httpsUrlValidator };
